import React from "react";
import PatientListSection from "./components/PatientListSection";
import AlertRadar from "./components/AlertRadar";
import PendingTasks from "./components/PendingTasks";
import AnnouncementsSection from "./components/NewsSection";
import AppointmentsSection from "./components/AppointmentsSection";
import AgendaSummary from "./components/AgendaSummary";
import styled from "styled-components";
import useUser from "state/user";
import { TherapistStatus } from "resources/constants/config";
import RequiredDocumentation from "./components/RequiredDocumentation";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
`;

const Therapist = () => {
  const [user] = useUser();

  return (
    <Container>
      {user.current.extraData?.status === TherapistStatus.ACTIVE && (
        <>
          <AgendaSummary />
          <AppointmentsSection />
          <PendingTasks />
          <AlertRadar />
          <PatientListSection />
          <AnnouncementsSection />
        </>
      )}
      {(user.current.extraData?.status === TherapistStatus.PENDING ||
        user.current.extraData?.status === TherapistStatus.REGISTERED) && (
        <RequiredDocumentation />
      )}
    </Container>
  );
};

export default Therapist;
